import aboutImage from '../img/about-bg.avif'; 

function About() {
  // Extracted text from the image for clarity
  const bioText = `I'm an illustrator who finds endless inspiration in nature's wonders, filling my work with vibrant colors and characters that brim with life and energy. I love exploring the ordinary to uncover the extraordinary, capturing those enchanting details that often go unnoticed. Being a mum to a wonderful wild boy has truly transformed my perspective, revealing the world's beauty in fresh, magical ways. While digital art is my current go-to, I deeply cherish the moments when I can dive into traditional mediums, getting my hands messy with paint and experiencing the tactile joy of creation.`;

  return (
    <div className="about-page">
        <div className="about-container">
            <div className="about-text">
                <p className="text-xl">
                    {bioText}
                </p>
                <p className="text-xl pt-4">
                    - Liv
                </p>
            </div>
            
            <div className='about-image'>
                <img 
                    src={aboutImage} 
                    alt="Liv, the illustrator, in an art gallery looking at paintings" 
                />
            </div>
        </div>
    </div>
    
  );
}

export default About;